module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABZ0lEQVQ4T+2SMUsDQRCF34xKkIhYWOQqC8HCRv0FYmUjmNJSEXb3Ki0E0cbLH4gWwt2EQIo0KRSjvyApLSxstbG2EcsQbkdOciGIAdO75bydb2fePsIER1WpVqttqOo2EW2rapcm6EcURdNBEDQB7GV9qlqeCJBNICJNItoBMAdg/s+AKIo4CIKWqk4VCoXDXq8XOeeOKUmSK2buGmPuxq2TjV4qlW4AvFtrLRFpfpfq9fpSmqbnAFYBnFhrH0dBIjID4F5Vn5j51nt/meuqWhmuMACdAVgkonNjzEu1Wp0tFosPGcBaey0iEYCLkQcq1Gg0Fvr9/tqg+MnMH2mangKYUdUVZo6NMa1M/xWQJEmbiHZzqvd+KwzDjogsqyo7515z7VeAiHQAbP4ExHG8z8xLg/qztbY9EUBEhk5nkMz8f8AYD7IoE9FRngPv/XoYhm8i8gbg+xdU9dk5ty4iZQDDyHvvD74Av/vuEyio+C8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/scene/sales.png
// module id = TvSv
// module chunks = 1